module.exports = __webpack_public_path__ + "img/MINI-code.e07c13c0.png";